"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxUpdateAccountCredentialsArgs = void 0;
var HxAccessTokenData_1 = require("./HxAccessTokenData");
function serializeHxUpdateAccountCredentialsArgs(_arg) {
    var output = [];
    output.push(_arg.refreshToken !== undefined);
    if (_arg.refreshToken !== undefined) {
        output.push(_arg.refreshToken.unprotect());
    }
    output.push(_arg.remoteRefreshToken !== undefined);
    if (_arg.remoteRefreshToken !== undefined) {
        output.push(_arg.remoteRefreshToken.unprotect());
    }
    output.push(_arg.accessTokenData !== undefined);
    if (_arg.accessTokenData !== undefined) {
        output.push(HxAccessTokenData_1.serializeHxAccessTokenData(_arg.accessTokenData));
    }
    output.push(_arg.incomingServerUserName !== undefined);
    if (_arg.incomingServerUserName !== undefined) {
        output.push(_arg.incomingServerUserName);
    }
    output.push(_arg.incomingServerPassword !== undefined);
    if (_arg.incomingServerPassword !== undefined) {
        output.push(_arg.incomingServerPassword.unprotect());
    }
    output.push(_arg.outgoingServerUserName !== undefined);
    if (_arg.outgoingServerUserName !== undefined) {
        output.push(_arg.outgoingServerUserName);
    }
    output.push(_arg.outgoingServerPassword !== undefined);
    if (_arg.outgoingServerPassword !== undefined) {
        output.push(_arg.outgoingServerPassword.unprotect());
    }
    output.push(_arg.sslCertificateValidation !== undefined);
    if (_arg.sslCertificateValidation !== undefined) {
        output.push(_arg.sslCertificateValidation);
    }
    return output;
}
exports.serializeHxUpdateAccountCredentialsArgs = serializeHxUpdateAccountCredentialsArgs;
